export const ALB_HTTP_RULE_TYPE = {
  FORWARD: 'FORWARD',
  STATIC: 'STATIC',
  REDIRECT: 'REDIRECT',
};

export const ALB_HTTP_RULE_TYPE$ = {
  [ALB_HTTP_RULE_TYPE.FORWARD]: 'Forward',
  [ALB_HTTP_RULE_TYPE.STATIC]: 'Static',
  [ALB_HTTP_RULE_TYPE.REDIRECT]: 'Redirect',
};

export const ALB_PROTOCOL = {
  HTTP: 'HTTP',
};

export const ALB_HTTP_RULE_REDIRECT_STATUS_CODE_RANGE = [301, 302, 303, 307, 308];
export const ALB_HTTP_RULE_STATIC_STATUS_CODE_RANGE = [200, 599];

export const ALB_HTTP_RULE_CONDITIONS_TYPE = {
  HEADER: 'HEADER',
  PATH: 'PATH',
  QUERY: 'QUERY',
  METHOD: 'METHOD',
  HOST: 'HOST',
  COOKIE: 'COOKIE',
  SOURCE_IP: 'SOURCE_IP',
};

export const ALB_HTTP_RULE_CONDITIONS_TYPE$ = {
  [ALB_HTTP_RULE_CONDITIONS_TYPE.HEADER]: 'Header',
  [ALB_HTTP_RULE_CONDITIONS_TYPE.PATH]: 'Path',
  [ALB_HTTP_RULE_CONDITIONS_TYPE.QUERY]: 'Query',
  [ALB_HTTP_RULE_CONDITIONS_TYPE.METHOD]: 'Method',
  [ALB_HTTP_RULE_CONDITIONS_TYPE.HOST]: 'Host',
  [ALB_HTTP_RULE_CONDITIONS_TYPE.COOKIE]: 'Cookie',
  [ALB_HTTP_RULE_CONDITIONS_TYPE.SOURCE_IP]: 'Source IP',
};

export const ALB_HTTP_RULE_CONDITIONS_CONDITION = {
  EXISTS: 'EXISTS',
  CONTAINS: 'CONTAINS',
  EQUALS: 'EQUALS',
  MATCHES: 'MATCHES',
  STARTS_WITH: 'STARTS_WITH',
  ENDS_WITH: 'ENDS_WITH',
};

export const ALB_HTTP_RULE_CONDITIONS_CONDITION$ = {
  [ALB_HTTP_RULE_CONDITIONS_CONDITION.EXISTS]: 'Exists',
  [ALB_HTTP_RULE_CONDITIONS_CONDITION.CONTAINS]: 'Contains',
  [ALB_HTTP_RULE_CONDITIONS_CONDITION.EQUALS]: 'Equals',
  [ALB_HTTP_RULE_CONDITIONS_CONDITION.MATCHES]: 'Matches',
  [ALB_HTTP_RULE_CONDITIONS_CONDITION.STARTS_WITH]: 'Starts With',
  [ALB_HTTP_RULE_CONDITIONS_CONDITION.ENDS_WITH]: 'Ends With',
};
